import _pt from "prop-types";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { FormattedNumber, IntlProvider } from 'react-intl';
export default function FieldPreviewValueCurrency(props) {
  const {
    value,
    currency,
    language
  } = props;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: language
  }, /*#__PURE__*/React.createElement(FormattedNumber, _extends({
    style: 'currency'
  }, {
    currency: currency,
    value: Number(value)
  })));
}
FieldPreviewValueCurrency.propTypes = {
  value: _pt.oneOfType([_pt.string, _pt.number]).isRequired,
  currency: _pt.string.isRequired,
  language: _pt.string.isRequired
};
//# sourceMappingURL=FieldPreviewValueCurrency.js.map